export const isElementNotFocusable = element => !element.hasAttribute('tabindex') || element.disabled || element.getAttribute('aria-disabled') === 'true';
export const ownerDocument = element => element && element.ownerDocument || document;
export const discoverCurrentElementFocused = element => ownerDocument(element).activeElement;
export function discoverNextChildToBeFocused(parent, child) {
  if (parent === child) return parent.firstChild;
  if (child && child.nextElementSibling) return child.nextElementSibling;
  return parent.firstChild;
}
export function discoverPrevChildToBeFocused(parent, child) {
  if (parent === child) return parent.firstChild;
  if (child && child.previousElementSibling) return child.previousElementSibling;
  return parent.lastChild;
}
export const focusChild = (parentElement, discoverElementToBeFocused) => {
  const currentElementFocused = discoverCurrentElementFocused(parentElement);
  let elementToBeFocused = discoverElementToBeFocused(parentElement, currentElementFocused);
  let hasNoFocusableChild = false;

  while (elementToBeFocused) {
    // Prevent infinite loop when the parent has no focusable child.
    if (elementToBeFocused === parentElement.firstChild) {
      if (hasNoFocusableChild) return false;
      hasNoFocusableChild = true;
    } // Move to the next child if it is not focusable.


    if (isElementNotFocusable(elementToBeFocused)) {
      elementToBeFocused = discoverElementToBeFocused(parentElement, elementToBeFocused);
    } else {
      elementToBeFocused.focus();
      return true;
    }
  }

  return false;
};
/*
 This function was designed to make a dom element navigable by keyboard
 promoting accessibility in web components and it returns an accessible element
 with methods to navigate throughout its children
*/

export const accessible = parentElement => ({
  navigateToNextChild() {
    focusChild(parentElement, discoverNextChildToBeFocused);
  },

  navigateToPrevChild() {
    focusChild(parentElement, discoverPrevChildToBeFocused);
  }

});